// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu_button {
  display: none;
}

.menu {
  position: fixed;
  z-index: 200;
  left: 0px;
  top: 0px;
  display: flex;
  justify-content: space-between;
  padding-left: 34px;
  padding-right: 34px;
  padding-top: 26px; /*31*/
  padding-bottom: 10px;
  width: 100%;
  transition: 0.5s all linear;
}

.menu_sticky {
  /*background-color:rgba(3, 6, 42, 0.7);*/
  background-color: rgba(255, 255, 255, 0.7);
  /*backdrop-filter: blur(2px);*/
  padding-top: 16px;
}
.menu_sticky .logo {
  position: relative;
  top: -3px;
}

.logo {
  cursor: pointer;
  /*padding-top:5px;*/
}

.menu_wrapper {
  display: flex;
}

.menu_item {
  font-family: var(--second-family);
  font-size: 22px;
  color: #040628;
  margin-right: 33px; /*32*/
  transition: 0.3s color linear;
  text-transform: uppercase;
  cursor: pointer;
}

.menu_item:last-child {
  margin-right: 0px;
}

.menu_item:HOVER, .menu_item_act {
  color: #FFFFFF !important;
}

.menu_sticky .menu_item:HOVER, .menu_sticky .menu_item_act {
  color: #A7AB28 !important;
}

@media all and (max-width: 991px) {
  .menu {
    padding-top: 31px; /*28 20*/
    padding-left: 30px; /*28*/
    padding-right: 30px; /*28*/
  }
  .menu_sticky {
    padding-top: 13px; /*31 28*/
  }
  .menu_sticky .logo {
    top: -1px;
  }
  .logo {
    position: relative;
    width: 122px;
    z-index: 202;
  }
  .menu_button {
    position: relative;
    z-index: 202;
    display: block;
    cursor: pointer;
  }
  /*
  .menu_wrapper_mobile
  {
  transition:1s opacity linear;
  }
  */
  .menu_wrapper {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 201;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 0px;
    opacity: 0;
    pointer-events: none;
    /*transition:1s opacity linear;*/
  }
  .menu_wrapper_show {
    pointer-events: auto;
    opacity: 1;
  }
  .menu_item {
    margin-right: 0px;
    padding-top: 10px;
    padding-bottom: 5px;
    color: #FFFFFF;
  }
  .menu_item:HOVER, .menu_item_act {
    color: #A7AB28 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/menu.scss"],"names":[],"mappings":"AAAA;EAEA,aAAA;AAAA;;AAEA;EAEA,eAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA,EAAA,KAAA;EACA,oBAAA;EACA,WAAA;EACA,2BAAA;AAAA;;AAEA;EAEA,wCAAA;EACA,0CAAA;EACA,8BAAA;EACA,iBAAA;AAAA;AACC;EAED,kBAAA;EACA,SAAA;AAAA;;AAGA;EAEA,eAAA;EACA,mBAAA;AADA;;AAGA;EAEA,aAAA;AADA;;AAGA;EAEA,iCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA,EAAA,KAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;AADA;;AAGA;EAEA,iBAAA;AADA;;AAGA;EAEA,yBAAA;AADA;;AAKC;EAED,yBAAA;AAHA;;AAMA;EAGA;IAEA,iBAAA,EAAA,QAAA;IACA,kBAAA,EAAA,KAAA;IACA,mBAAA,EAAA,KAAA;EANE;EAQF;IAEA,iBAAA,EAAA,QAAA;EAPE;EAQD;IAED,SAAA;EAPE;EAUF;IAEA,kBAAA;IACA,YAAA;IACA,YAAA;EATE;EAWF;IAEA,kBAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;EAVE;EAYF;;;;;GAAA;EAMA;IAEA,eAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,oCAAA;IACA,0BAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;IACA,UAAA;IACA,oBAAA;IACA,gCAAA;EAXE;EAaF;IAEA,oBAAA;IACA,UAAA;EAZE;EAcF;IAEA,iBAAA;IACA,iBAAA;IACA,mBAAA;IACA,cAAA;EAbE;EAeD;IAED,yBAAA;EAdE;AACF","sourcesContent":[".menu_button\n{\ndisplay:none;\n}\n.menu\n{\nposition:fixed;\nz-index:200;\nleft:0px;\ntop:0px;\ndisplay:flex;\njustify-content:space-between;\npadding-left:34px;\npadding-right:34px;\npadding-top:26px;/*31*/\npadding-bottom:10px;\nwidth:100%;\ntransition:0.5s all linear;\n}\n.menu_sticky\n{\n/*background-color:rgba(3, 6, 42, 0.7);*/\nbackground-color:rgba(255, 255, 255, 0.7);\n/*backdrop-filter: blur(2px);*/\npadding-top:16px;\n\t.logo\n\t{\nposition:relative;\ntop:-3px;\n\t}\n}\n.logo\n{\ncursor:pointer;\n/*padding-top:5px;*/\n}\n.menu_wrapper\n{\ndisplay:flex;\n}\n.menu_item\n{\nfont-family:var(--second-family);\nfont-size:22px;\ncolor:#040628;\nmargin-right:33px;/*32*/\ntransition:0.3s color linear;\ntext-transform:uppercase;\ncursor:pointer;\n}\n.menu_item:last-child\n{\nmargin-right:0px;\n}\n.menu_item:HOVER, .menu_item_act\n{\ncolor:#FFFFFF !important;\n}\n.menu_sticky\n{\n\t.menu_item:HOVER, .menu_item_act\n\t{\ncolor:#A7AB28 !important;\n\t}\n}\n@media all and (max-width:991px)\n{\n\n.menu\n{\npadding-top:31px;/*28 20*/\npadding-left:30px;/*28*/\npadding-right:30px;/*28*/\n}\n.menu_sticky\n{\npadding-top:13px; /*31 28*/\n\t.logo\n\t{\ntop:-1px;\n\t}\n}\n.logo\n{\nposition:relative;\nwidth:122px;\nz-index:202;\n}\n.menu_button\n{\nposition:relative;\nz-index:202;\ndisplay:block;\ncursor:pointer;\n}\n/*\n.menu_wrapper_mobile\n{\ntransition:1s opacity linear;\n}\n*/\n.menu_wrapper\n{\nposition:fixed;\ntop:0px;\nleft:0px;\nz-index:201;\nwidth:100%;\nheight:100%;\nbackground-color:rgba(0, 0, 0, 0.5);\nbackdrop-filter: blur(2px);\nflex-direction:column;\nalign-items:center;\njustify-content:center;\npadding-top:0px;\nopacity:0;\npointer-events:none;\n/*transition:1s opacity linear;*/\n}\n.menu_wrapper_show\n{\npointer-events:auto;\nopacity:1;\n}\n.menu_item\n{\nmargin-right:0px;\npadding-top:10px;\npadding-bottom:5px;\ncolor:#FFFFFF;\n}\n\t.menu_item:HOVER, .menu_item_act\n\t{\ncolor:#A7AB28 !important;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
